import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { DECO_STACK, SELL_CLOSER, SELL_IMAGE, SELL_STEPS } from './salesData';

/**
 * APLICACIÓN COMERCIAL. Del recetario al catálogo: tres pasos cortos, una
 * fotografía de cookies presentadas para la venta y el cierre sobre cacao.
 */
export function SellSection() {
  return <section id="vender" className="relative scroll-mt-24 overflow-hidden bg-ivory py-14 sm:py-20" aria-labelledby="sell-title" data-id="element-233" data-mp="354m3s06uusuc">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-234" data-mp="1l0y4mjouoen">
        <div className="max-w-2xl" data-id="element-235" data-mp="3j2twfvwuz7zp">
          <SectionTag data-id="element-236" data-mp="3j1ipxoc13m4w">De la cocina al catálogo</SectionTag>
          <h2 id="sell-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-237" data-mp="3o1n8djwhyqxr">
            Prepará, sumá a tu catálogo y vendé
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal/65" data-id="element-238" data-mp="kd20vzzl2ytc">
            Menos “aprendé cómo se hace” y más “acá tenés las recetas”. Abrís el tomo, elegís la
            variedad y la producís.
          </p>
        </div>

        <div className="mt-9 grid gap-9 lg:grid-cols-12 lg:items-center lg:gap-14" data-id="element-239" data-mp="18y3nx4r9t8a8">
          <ol className="lg:col-span-6" data-id="element-240" data-mp="1mt61me2d01xl">
            {SELL_STEPS.map((step, index) => <motion.li key={step.number} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 4) * 0.045
          }} className="flex items-start gap-4 border-b border-warm/80 py-5 first:border-t sm:gap-6" data-id="element-241" data-mp="1i039899biyiz" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-caramel-pale font-display text-[0.9rem] text-caramel sm:h-12 sm:w-12 sm:text-[1.05rem]" data-id="element-242" data-mp="bcpvxcglwznx">
                  {step.number}
                </span>
                <div data-id="element-243" data-mp="2befpxoxgcnvh">
                  <h3 className="font-display text-[1.1rem] leading-tight text-charcoal sm:text-[1.35rem]" data-id="element-244" data-mp="2bfqq7erovdhu">
                    {step.title}
                  </h3>
                  <p className="mt-1.5 max-w-md font-sans text-[0.88rem] leading-relaxed text-charcoal/60 sm:text-[0.94rem]" data-id="element-245" data-mp="2lcvblcdpn4xl">
                    {step.body}
                  </p>
                </div>
              </motion.li>)}
          </ol>

          <motion.figure initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.32,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative lg:col-span-6" data-id="element-246" data-mp="2ubz04vvnccjh">
            <div className="overflow-hidden rounded-5xl shadow-bakery" data-id="element-247" data-mp="3940szvzau5a0">
              <img src={SELL_IMAGE} alt="Cookies gruesas presentadas en cajas de cartón kraft y bolsas de pastelería, listas para la venta." loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-248" data-mp="3d39p37htaf8q" />
            </div>
            {/* Pila de cookies que sobresale del contenedor. */}
            <img src={DECO_STACK} alt="" aria-hidden loading="lazy" className="absolute -bottom-6 -left-4 hidden h-28 w-28 rounded-full object-cover shadow-bakery sm:block sm:h-36 sm:w-36" data-id="element-249" data-mp="nhq045vefvzb" />
          </motion.figure>
        </div>

        <div className="mt-14 overflow-hidden rounded-5xl bg-charcoal" data-id="element-250" data-mp="1bdu1kmqvatzm">
          <div className="p-7 sm:p-11" data-id="element-251" data-mp="16gamxlq9cf75">
            <p className="max-w-4xl font-display text-[1.35rem] leading-[1.25] text-white sm:text-[1.85rem]" data-id="element-252" data-mp="16f9abctlfknb">
              {SELL_CLOSER}
            </p>
          </div>
        </div>
      </div>
    </section>;
}